import PromptTextTextarea from './PromptTextTextarea';

// interface PromptTextAreaProps {}

const PromptTextArea = () => {
  return <PromptTextTextarea />;
};

export default PromptTextArea;
